import {Component} from '@angular/core';
import {PAGES_AND_PATHS} from 'src/app/constants/pages-and-paths';
import {ShareEntitiesEnums} from '../../enums/chat-enums';

@Component({
  selector: 'app-my-content',
  templateUrl: './my-content.component.html',
})
export class MyContentComponent {
  tabSelected = 'lists';
  openDropdown = false;
  PAGES_AND_PATHS = PAGES_AND_PATHS;
  protected readonly ShareEntitiesEnums = ShareEntitiesEnums;
  postUrl = '';
  postToShare: any = null;

  constructor() {
  }

  selectTab(tabSelected: string): void {
    this.tabSelected = tabSelected;
  }

  onScroll(): void {
  }
}
